import { render, staticRenderFns } from "./AppStrategyidAdd.vue?vue&type=template&id=2fa9824a"
import script from "./AppStrategyidAdd.vue?vue&type=script&lang=js"
export * from "./AppStrategyidAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports